import { clsx } from '@digital-spiders/misc-utils';
import type { Closer } from '../../api/types';
import { useCloser } from '../../utils/projectUtils';
import * as styles from './CloserInfo.module.scss';
import Image from './Image';

export interface CloserInfoProps {
  closers: Array<Closer>;
  className?: string;
}

const CloserInfo = ({ closers, className }: CloserInfoProps): React.ReactElement => {
  const closer = useCloser(closers);

  return closer ? (
    <div className={clsx(styles.closerContainer, className)}>
      <div className={styles.closerImageContainer}>
        <Image image={closer.image} />
      </div>
      <div className={styles.closerTextContainer}>
        <span className={styles.closerSpan}>Meeting with</span>
        <span className={styles.closerName}>{closer.name}</span>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CloserInfo;
